export const resInterceptor = (req) => {
  return req;
};
